import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const init = () => {

    const sections = document.querySelectorAll('.section-media');

    sections.forEach(section => {
        const captionText = section.querySelectorAll('.section-media__background-caption-text');

        captionText.forEach((media, index) => {

            gsap.fromTo(media,
                {
                    x: 100 + '%',
                },
                {
                    x: (-1 * 100) + '%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: section,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true
                    }
            })
        })
    })

}

export default init;
